import { range } from "lodash"
import { PhaserUtils } from "../../utils/PhaserUtils"

export enum WomAudio {
    // Round 1 narrator audio
    ROUND_1_INTRO = "round-1-intro.mp3",
    // Round 2 narrator audio
    ROUND_2_INTRO = "round-2-intro.mp3",
    // Misc sounds
    ADDICTED = "addicted.mp3",
    ADDICTION_BUZZER = "addiction-buzzer.mp3",
    CHIMES = "chimes.mp3",
    DINGWALL = "cost-dingwall.mp3",
    GREAT_CHOICE = "great-choice.mp3",
    LUCKY_SO_FAR = "lucky-so-far.mp3",
    REWARD_BELL = "reward-bell.mp3",
    SPINNING = "spinning.mp3",
    WAH_WAH = "wahwah.mp3",
}

export enum WomExitAssets {
    // Testimonial Outro Assets
    OUTRO1 = "MisfortuneOUTRO1",

    BUDDY_TESTIMONIALS_INTRO = "MisfortuneBUDDY_TESTIMONIALS_INTRO",

    TESTIMONIAL_1 = "MisfortuneTESTIMONIAL_1",
    TESTIMONIAL_2 = "MisfortuneTESTIMONIAL_2",
    TESTIMONIAL_3 = "MisfortuneTESTIMONIAL_3",

    TESTIMONIAL_1_IMAGE = "MisfortuneTESTIMONIAL_1_IMAGE",
    TESTIMONIAL_2_IMAGE = "MisfortuneTESTIMONIAL_2_IMAGE",
    TESTIMONIAL_3_IMAGE = "MisfortuneTESTIMONIAL_3_IMAGE",
}

export enum WomImage {
    BACKGROUND = "background.jpg",
    ARROW = "arrow.png"
}

export enum WomAtlas {
    WHEELS = "wheels.json"
}

// tslint:disable-next-line
function loadWomAssets(loader: {audio}) {
    const spins = range(1, 7)
    const rounds = range(1, 4)

    spins.forEach(spin => {
        const round1Spin = `round-1-spin-${spin}.mp3`
        const round2Spin = `round-2-spin-${spin}.mp3`
        const round1Change = `round-1-change-${spin}.mp3`
        const round2Change = `round-2-change-${spin}.mp3`
        const loss = `loss-${spin}.mp3`

        loader.audio(round1Spin, round1Spin)
        loader.audio(round1Change, round1Change)
        loader.audio(round2Spin, round2Spin)
        loader.audio(round2Change, round2Change)
        loader.audio(loss, loss)
    })

    rounds.forEach(round => {
        const viewScores = `round-${round}-view-scores.mp3`
        const end = `round-${round}-end.mp3`

        loader.audio(viewScores, viewScores)
        loader.audio(end, end)
    })
}

export function loadAssets(game: Phaser.Game) {
    const load = PhaserUtils.makeLoader(game, "wheel-of-misfortune")
    load.autoLoad({imageEnum: WomImage, audioEnum: WomAudio, atlasEnum: WomAtlas})
    loadWomAssets(load)
}